module.exports = __webpack_public_path__ + "img/FQSP00.d12bba61.svg";